/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SubscriptionsPaginationQueryVariables = {
    count: number;
    cursor?: string | null;
    accountID: string;
    before: string;
    after: string;
};
export type SubscriptionsPaginationQueryResponse = {
    readonly account: {
        readonly " $fragmentRefs": FragmentRefs<"Subscriptions_account">;
    } | null;
};
export type SubscriptionsPaginationQuery = {
    readonly response: SubscriptionsPaginationQueryResponse;
    readonly variables: SubscriptionsPaginationQueryVariables;
};



/*
query SubscriptionsPaginationQuery(
  $count: Int!
  $cursor: String
  $accountID: ID!
  $before: Time!
  $after: Time!
) {
  account: node(id: $accountID) {
    __typename
    ...Subscriptions_account_2pOVhH
    id
  }
}

fragment SubscriptionOverview_subscription on Subscription {
  id
  createdAt
  service {
    name
    imageURL
    id
  }
  usage(before: $before, after: $after, intervalSeconds: 3600) {
    intervals {
      startDate
      endDate
      totalCosts {
        value
        currency
      }
    }
  }
}

fragment Subscriptions_account_2pOVhH on Account {
  subscriptions(first: $count, after: $cursor) {
    edges {
      node {
        id
        ...SubscriptionOverview_subscription
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountID"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v5 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "accountID"
  }
],
v6 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v7 = {
  "kind": "Variable",
  "name": "before",
  "variableName": "before"
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SubscriptionsPaginationQuery",
    "selections": [
      {
        "alias": "account",
        "args": (v5/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count"
              },
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor"
              }
            ],
            "kind": "FragmentSpread",
            "name": "Subscriptions_account"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "SubscriptionsPaginationQuery",
    "selections": [
      {
        "alias": "account",
        "args": (v5/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v10/*: any*/),
                "concreteType": "SubscriptionConnection",
                "kind": "LinkedField",
                "name": "subscriptions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SubscriptionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Subscription",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Service",
                            "kind": "LinkedField",
                            "name": "service",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "name",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "imageURL",
                                "storageKey": null
                              },
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              (v6/*: any*/),
                              (v7/*: any*/),
                              {
                                "kind": "Literal",
                                "name": "intervalSeconds",
                                "value": 3600
                              }
                            ],
                            "concreteType": "SubscriptionUsage",
                            "kind": "LinkedField",
                            "name": "usage",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UsageInterval",
                                "kind": "LinkedField",
                                "name": "intervals",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "startDate",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "endDate",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Amount",
                                    "kind": "LinkedField",
                                    "name": "totalCosts",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "value",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "currency",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v10/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "Subscriptions_subscriptions",
                "kind": "LinkedHandle",
                "name": "subscriptions"
              }
            ],
            "type": "Account",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "40f8b10234afed91bf1404aafdf7f768",
    "id": null,
    "metadata": {},
    "name": "SubscriptionsPaginationQuery",
    "operationKind": "query",
    "text": "query SubscriptionsPaginationQuery(\n  $count: Int!\n  $cursor: String\n  $accountID: ID!\n  $before: Time!\n  $after: Time!\n) {\n  account: node(id: $accountID) {\n    __typename\n    ...Subscriptions_account_2pOVhH\n    id\n  }\n}\n\nfragment SubscriptionOverview_subscription on Subscription {\n  id\n  createdAt\n  service {\n    name\n    imageURL\n    id\n  }\n  usage(before: $before, after: $after, intervalSeconds: 3600) {\n    intervals {\n      startDate\n      endDate\n      totalCosts {\n        value\n        currency\n      }\n    }\n  }\n}\n\nfragment Subscriptions_account_2pOVhH on Account {\n  subscriptions(first: $count, after: $cursor) {\n    edges {\n      node {\n        id\n        ...SubscriptionOverview_subscription\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '64f9b79e9a932f6b55488a3ad4555655';
export default node;
